export default __webpack_public_path__ + "static/media/lightPurpleArrow.63493755.svg";